import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  cleanCatalogCiiuLevel1,
  cleanCatalogCiiuLevel2,
  cleanCatalogCiiuLevel3,
  cleanCatalogCiiuLevel4,
  cleanCatalogCiiuLevel5,
  cleanCatalogCiiuLevel6,
  selectCatalogCiiuLevel1,
  selectCatalogCiiuLevel2,
  selectCatalogCiiuLevel3,
  selectCatalogCiiuLevel4,
  selectCatalogCiiuLevel5,
  selectCatalogCiiuLevel6,
  startLoadingCatalogCiiuByParentLocal
} from "../../app/actions/catalogCiiuActions";

import { cleanContinent, selectContinent } from "../../app/actions/continentActions";
import { startLoadingCountriesByRegionIdLocal } from "../../app/actions/countryActions";
import { cleanRegion, selectRegion, startLoadingRegionByContinentIdLocal } from "../../app/actions/regionActions";

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { cleanCatalogSectionLevel1, cleanCatalogSectionLevel2, cleanCatalogSectionLevel3, selectCatalogSectionLevel1, selectCatalogSectionLevel2, selectCatalogSectionLevel3, startLoadingCatalogSectionByParentLocal } from "../actions/catalogSectionActions";
import { sanitizePlainText } from "../helpers/sanitizePlainTextHelper";
import { syncMultilevelLeafValues } from "../helpers/helperConcat";
import { shouldApplyRegex } from "../helpers/sanitizeModeHelper";

import { cleanCatalogInstitutionLevel1, cleanCatalogInstitutionLevel2, cleanCatalogInstitutionLevel3, selectCatalogInstitutionLevel1, selectCatalogInstitutionLevel2, selectCatalogInstitutionLevel3, startLoadingCatalogInstitutionByParentLocal } from "../actions/catalogInstitutionActions";
import { cleanCatalogPhaseLevel1, cleanCatalogPhaseLevel2, cleanCatalogPhaseLevel3, cleanCatalogPhaseLevel4, cleanCatalogPhaseLevel5, selectCatalogPhaseLevel1, selectCatalogPhaseLevel2, selectCatalogPhaseLevel3, selectCatalogPhaseLevel4, selectCatalogPhaseLevel5, startLoadingCatalogPhaseByParentLocal } from "../actions/catalogPhaseActions";

const useFormValidations = (callback, data, moduleConfigs) => {

  const [values, setValues] = useState(data);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const userTriedSubmitRef = useRef(false);
  const originalValuesRef = useRef(data ? { ...data } : data);

  useEffect(() => {
    originalValuesRef.current = data ? { ...data } : data;
  }, [data]);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
  }, [errors, isSubmitting]);

  useEffect(() => {
    const firstField = Object.keys(errors || {})[0];
    if (!firstField) {
      return;
    }
    const el = document.getElementById(firstField);
    if (el?.scrollIntoView) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [errors]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (event) {
      userTriedSubmitRef.current = true;
      preFormatValues(values);
      const nextErrors = validate(values);
      setErrors(nextErrors);
      if (Object.keys(nextErrors).length > 0) {
        setIsSubmitting(false);
        Swal.fire({
          icon: "warning",
          title: t("titles.validation", t("titles.error")),
          text: t(
            "validations.required-fields",
            "Hay campos obligatorios o inválidos. Revisa las celdas marcadas en rojo."
          )
        });
        return;
      }
      setIsSubmitting(true);
    }
  };

  const handleChange = (event, idField) => {

    const fieldFound = getFieldInfo(idField);

    if (event) {

      if (fieldFound && fieldFound.data_type === "string" && fieldFound.type === "field") {
        event.persist();
        setValues((values) => ({ ...values, [event.target.name]: event.target.value }));
      } else if (fieldFound && fieldFound.data_type === "number" && fieldFound.type === "field") {
        if (event.target.value) {
          const regexToValidateString = fieldFound.regex;
          let regexToValidate = new RegExp(regexToValidateString);
          if (regexToValidate.test(event.target.value)) {
            event.persist();
            setValues((values) => ({ ...values, [event.target.name]: event.target.value }));
          }
        } else {
          event.persist();
          setValues((values) => ({ ...values, [event.target.name]: event.target.value }));
        }

      }

      else if (fieldFound && fieldFound.data_type === "integer" && fieldFound.type === "relation") {
        const nextVal = event != null ? event : "";
        const nextValues = { ...values, [idField]: nextVal };
        setValues((current) => ({ ...current, [idField]: nextVal }));
        if (userTriedSubmitRef.current) {
          setErrors(validate(nextValues));
          setIsSubmitting(false);
        }
      }
      else if (fieldFound && fieldFound.data_type === "datetime" && fieldFound.type === "field") {
        setValues((values) => ({ ...values, [idField]: event }));
      }
      else if (fieldFound && fieldFound.data_type === "datetime_year" && fieldFound.type === "field") {
        if (event != null) {
          setValues((values) => ({ ...values, [idField]: event }));
        } else {
          setValues((values) => ({ ...values, [idField]: null }));
        }
      }
      else if (event && typeof event === "object" && !Array.isArray(event) && event.id != null && idField) {
        setValues((current) => ({ ...current, [idField]: event }));
      }

    }

  };


  const handleChangeMulti = (event, idField) => {

    const fieldFound = getFieldInfo(idField);

    if (event != null) {

      if (fieldFound && fieldFound.data_type === "string" && fieldFound.type === "field") {

        if (idField === 'general_adaptation') {
          if (event.length > 0) {
            setValues((values) => ({ ...values, 'general_adaptation_list': event }));
            setValues((values) => ({ ...values, [idField]: event }));
            let eventString = [];
            event.forEach(element => {

              eventString.push(element.description);
            });

            const stringPuntoYComaSeparated = eventString.join(";");

            setValues((values) => ({ ...values, 'general_adaptation_string_list': stringPuntoYComaSeparated }));

          } else {
            setValues((values) => ({ ...values, 'general_adaptation_list': [] }));
            setValues((values) => ({ ...values, [idField]: [] }));
            setValues((values) => ({ ...values, 'general_adaptation_string_list': [] }));
          }
        } else if (idField === 'structural_adaptation') {
          if (event.length > 0) {
            setValues((values) => ({ ...values, 'structural_adaptation_list': event }));
            setValues((values) => ({ ...values, [idField]: event }));
            let eventString = [];
            event.forEach(element => {

              eventString.push(element.description);
            });

            const stringPuntoYComaSeparated = eventString.join(";");

            setValues((values) => ({ ...values, 'structural_adaptation_string_list': stringPuntoYComaSeparated }));
          } else {
            setValues((values) => ({ ...values, 'structural_adaptation_list': [] }));
            setValues((values) => ({ ...values, [idField]: [] }));
            setValues((values) => ({ ...values, 'structural_adaptation_string_list': [] }));
          }
        } else if (idField === 'specific_adaptation') {
          console.log("ELEMENTOS RECIBIDOS DESDE EL SELECT:", event);
          if (event.length > 0) {
            setValues((values) => ({ ...values, 'specific_adaptation_list': event }));
            setValues((values) => ({ ...values, [idField]: event }));
            let eventString = [];
            event.forEach(element => {

              eventString.push(element.description);
            });

            const stringPuntoYComaSeparated = eventString.join(";");

            setValues((values) => ({ ...values, 'specific_adaptation_string_list': stringPuntoYComaSeparated }));
          } else {
            setValues((values) => ({ ...values, 'specific_adaptation_list': [] }));
            setValues((values) => ({ ...values, [idField]: [] }));
            setValues((values) => ({ ...values, 'specific_adaptation_string_list': [] }));
          }
        }

      } else if (fieldFound && fieldFound.data_type === "list" && fieldFound.type === "relation") {

        /*
         if (idField === 'catalogproblem_list') {
          event.forEach(element => {
            element.reference_id=1
          });
         }
          */

        if (event.length > 0) {
          //console.log("A1, event", event);
          setValues((values) => ({ ...values, [idField]: event }));

          let eventString = [];
          let problemConcat = "";
          let index = 0;

          event.forEach(element => {

            eventString.push(element.description);

            if (index === 0) {
              problemConcat = problemConcat.concat(element.id);
            } else {
              problemConcat = problemConcat.concat(";", element.id);
            }

            index = index + 1;
          });

          const stringPuntoYComaSeparated = eventString.join(";");

          setValues((values) => ({ ...values, 'catalogproblem_string_list': stringPuntoYComaSeparated }));
          setValues((values) => ({ ...values, 'catalogproblem_ids': problemConcat }));
        } else {

          setValues((values) => ({ ...values, [idField]: [] }));

          setValues((values) => ({ ...values, 'catalogproblem_string_list': [] }));
          setValues((values) => ({ ...values, 'catalogproblem_ids': "" }));
        }

      }

    } else {

      setValues((values) => ({ ...values, [idField]: "" }));

    }

  };

  const handleChangeCatalogCiiu = (event, level) => {

    var setCleanCatalogCiiuLevel = {
      1: () => cleanCatalogCiiuLevel1(),
      2: () => cleanCatalogCiiuLevel2(),
      3: () => cleanCatalogCiiuLevel3(),
      4: () => cleanCatalogCiiuLevel4(),
      5: () => cleanCatalogCiiuLevel5(),
      6: () => cleanCatalogCiiuLevel6(),
    };

    var setSelectCatalogCiiuLevel = {
      1: () => selectCatalogCiiuLevel1(event),
      2: () => selectCatalogCiiuLevel2(event),
      3: () => selectCatalogCiiuLevel3(event),
      4: () => selectCatalogCiiuLevel4(event),
      5: () => selectCatalogCiiuLevel5(event),
      6: () => selectCatalogCiiuLevel6(event),
    };

    /*
    var setStartLoadingCatalogCiiuByParent = {
        1: () => startLoadingCatalogCiiuByParent(event.id, 2),
        2: () => startLoadingCatalogCiiuByParent(event.id, 3),
        3: () => startLoadingCatalogCiiuByParent(event.id, 4),
        4: () => startLoadingCatalogCiiuByParent(event.id, 5),
        5: () => startLoadingCatalogCiiuByParent(event.id, 6),
        6: () => startLoadingCatalogCiiuByParent(event.id, 7),
    };
    */

    var setStartLoadingCatalogCiiuByParentLocal = {
      1: () => startLoadingCatalogCiiuByParentLocal(event.id, 2),
      2: () => startLoadingCatalogCiiuByParentLocal(event.id, 3),
      3: () => startLoadingCatalogCiiuByParentLocal(event.id, 4),
      4: () => startLoadingCatalogCiiuByParentLocal(event.id, 5),
      5: () => startLoadingCatalogCiiuByParentLocal(event.id, 6),
      6: () => startLoadingCatalogCiiuByParentLocal(event.id, 7),
    };

    var getLevelsToIterate = {
      1: 5,
      2: 4,
      3: 3,
      4: 2,
      5: 1
    };

    var setCleanCatalogCiiuLevelE = {
      1: () => cleanCatalogCiiuLevel1(),
      2: () => cleanCatalogCiiuLevel2(),
      3: () => cleanCatalogCiiuLevel3(),
      4: () => cleanCatalogCiiuLevel4(),
      5: () => cleanCatalogCiiuLevel5(),
      6: () => cleanCatalogCiiuLevel6(),
    };

    var getLevelsToIterateE = {
      1: 6,
      2: 5,
      3: 4,
      4: 3,
      5: 2,
      6: 1,
    };

    if (event != null) {

      if (event.code === 0) {
        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogciiu_levels: event }));

        dispatch(cleanCatalogCiiuLevel1());

        dispatch(selectCatalogCiiuLevel1(event));

        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogCiiuLevel2: "" }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogCiiuLevel3: "" }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogCiiuLevel4: "" }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogCiiuLevel5: "" }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogCiiuLevel6: "" }));

      } else {

        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogciiu_level${level}`]: event }));

        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogciius_id`]: event.id }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogciiu_levels`]: concatCiiuLevels(valuesCiiu, event, level) }));

        let setCleanCatalogCiiuLevelActual = setCleanCatalogCiiuLevel[level];
        dispatch(setCleanCatalogCiiuLevelActual());

        let setSelectCatalogCiiuLevelActual = setSelectCatalogCiiuLevel[level];
        dispatch(setSelectCatalogCiiuLevelActual());

        let numberOfLevelsIterate = getLevelsToIterate[level];

        for (let i = 0; i < numberOfLevelsIterate; i++) {
          let flagHelper = level + 1;
          setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogciiu_level${i + flagHelper}`]: "" }));
        }

        let setStartLoadingCatalogCiiuByParentActual = setStartLoadingCatalogCiiuByParentLocal[level];

        dispatch(setStartLoadingCatalogCiiuByParentActual());

      }
    } else {

      let setCleanCatalogCiiuLevelActualE = setCleanCatalogCiiuLevelE[level];
      dispatch(setCleanCatalogCiiuLevelActualE());

      let numberOfLevelsIterateE = getLevelsToIterateE[level];

      for (let i = 0; i < numberOfLevelsIterateE; i++) {
        let flagHelperE = level;
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogciiu_level${i + flagHelperE}`]: "" }));

        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogciius_id`]: level === 1 ? "" : valuesCiiu[`catalogciiu_level${level - 1}`].id }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogciiu_levels`]: concatCiiuLevelsNoEvent(values, level) }));

      }
    }
  };

  const handleChangeCatalogSection = (event, level) => {

    var setCleanCatalogSectionLevel = {
      1: () => cleanCatalogSectionLevel1(),
      2: () => cleanCatalogSectionLevel2(),
      3: () => cleanCatalogSectionLevel3(),

    };

    var setSelectCatalogSectionLevel = {
      1: () => selectCatalogSectionLevel1(event),
      2: () => selectCatalogSectionLevel2(event),
      3: () => selectCatalogSectionLevel3(event),

    };

    /*
    var setStartLoadingCatalogSectionByParent = {
        1: () => startLoadingCatalogSectionByParent(event.id, 2),
        2: () => startLoadingCatalogSectionByParent(event.id, 3),
        3: () => startLoadingCatalogSectionByParent(event.id, 4),
        4: () => startLoadingCatalogSectionByParent(event.id, 5),
    };
    */

    var setStartLoadingCatalogSectionByParentLocal = {
      1: () => startLoadingCatalogSectionByParentLocal(event.id, 2),
      2: () => startLoadingCatalogSectionByParentLocal(event.id, 3),
      3: () => startLoadingCatalogSectionByParentLocal(event.id, 4),

    };

    /*var getLevelsToIterate = {
      1: 3,
      2: 2,
      3: 1,
    };*/

    var getLevelsToIterate = {
      1: 2,
      2: 1,

    };

    var setCleanCatalogSectionLevelE = {
      1: () => cleanCatalogSectionLevel1(),
      2: () => cleanCatalogSectionLevel2(),
      3: () => cleanCatalogSectionLevel3(),

    };

    var getLevelsToIterateE = {
      1: 3,
      2: 2,
      3: 1,

    };

    if (event != null) {

      if (event.code === 0) {
        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogsection_levels: event }));

        dispatch(cleanCatalogSectionLevel1());

        dispatch(selectCatalogSectionLevel1(event));

        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogSectionLevel2: "" }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogSectionLevel3: "" }));

      } else {

        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogsection_level${level}`]: event }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogsections_id`]: event.id }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogsection_levels`]: concatSectionLevels(valuesCiiu, event, level) }));

        let setCleanCatalogSectionLevelActual = setCleanCatalogSectionLevel[level];
        dispatch(setCleanCatalogSectionLevelActual());

        let setSelectCatalogSectionLevelActual = setSelectCatalogSectionLevel[level];
        dispatch(setSelectCatalogSectionLevelActual());

        let numberOfLevelsIterate = getLevelsToIterate[level];

        for (let i = 0; i < numberOfLevelsIterate; i++) {
          let flagHelper = level + 1;
          setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogsection_level${i + flagHelper}`]: "" }));
        }

        let setStartLoadingCatalogSectionByParentActual = setStartLoadingCatalogSectionByParentLocal[level];

        dispatch(setStartLoadingCatalogSectionByParentActual());

      }
    } else {

      let setCleanCatalogSectionLevelActualE = setCleanCatalogSectionLevelE[level];
      dispatch(setCleanCatalogSectionLevelActualE());

      let numberOfLevelsIterateE = getLevelsToIterateE[level];

      for (let i = 0; i < numberOfLevelsIterateE; i++) {
        let flagHelperE = level;
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogsection_level${i + flagHelperE}`]: "" }));

        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogsections_id`]: level === 1 ? "" : valuesCiiu[`catalogsection_level${level - 1}`].id }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogsection_levels`]: concatSectionLevelsNoEvent(values, level) }));

      }
    }
  };

  const handleChangeCatalogPhase = (event, level) => {

    var setCleanCatalogPhaseLevel = {
      1: () => cleanCatalogPhaseLevel1(),
      2: () => cleanCatalogPhaseLevel2(),
      3: () => cleanCatalogPhaseLevel3(),
      4: () => cleanCatalogPhaseLevel4(),
      5: () => cleanCatalogPhaseLevel5(),
    };

    var setSelectCatalogPhaseLevel = {
      1: () => selectCatalogPhaseLevel1(event),
      2: () => selectCatalogPhaseLevel2(event),
      3: () => selectCatalogPhaseLevel3(event),
      4: () => selectCatalogPhaseLevel4(event),
      5: () => selectCatalogPhaseLevel5(event),
    };

    /*
    var setStartLoadingCatalogPhaseByParent = {
        1: () => startLoadingCatalogPhaseByParent(event.id, 2),
        2: () => startLoadingCatalogPhaseByParent(event.id, 3),
        3: () => startLoadingCatalogPhaseByParent(event.id, 4),
        4: () => startLoadingCatalogPhaseByParent(event.id, 5),
    };
    */

    var setStartLoadingCatalogPhaseByParentLocal = {
      1: () => startLoadingCatalogPhaseByParentLocal(event.id, 2),
      2: () => startLoadingCatalogPhaseByParentLocal(event.id, 3),
      3: () => startLoadingCatalogPhaseByParentLocal(event.id, 4),
      4: () => startLoadingCatalogPhaseByParentLocal(event.id, 5),
      5: () => startLoadingCatalogPhaseByParentLocal(event.id, 6),
    };

    var getLevelsToIterate = {
      1: 4,
      2: 3,
      3: 2,
      4: 1,
    };

    var setCleanCatalogPhaseLevelE = {
      1: () => cleanCatalogPhaseLevel1(),
      2: () => cleanCatalogPhaseLevel2(),
      3: () => cleanCatalogPhaseLevel3(),
      4: () => cleanCatalogPhaseLevel4(),
      5: () => cleanCatalogPhaseLevel5(),
    };

    var getLevelsToIterateE = {
      1: 5,
      2: 4,
      3: 3,
      4: 2,
      5: 1,
    };

    if (event != null) {

      if (event.code === 0) {
        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogphase_levels: event }));

        dispatch(cleanCatalogPhaseLevel1());

        dispatch(selectCatalogPhaseLevel1(event));

        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogPhaseLevel2: "" }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogPhaseLevel3: "" }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogPhaseLevel4: "" }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogPhaseLevel5: "" }));

      } else {

        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogphase_level${level}`]: event }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogphases_id`]: event.id }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogphase_levels`]: concatPhaseLevels(valuesCiiu, event, level) }));

        let setCleanCatalogPhaseLevelActual = setCleanCatalogPhaseLevel[level];
        dispatch(setCleanCatalogPhaseLevelActual());

        let setSelectCatalogPhaseLevelActual = setSelectCatalogPhaseLevel[level];
        dispatch(setSelectCatalogPhaseLevelActual());

        let numberOfLevelsIterate = getLevelsToIterate[level];

        for (let i = 0; i < numberOfLevelsIterate; i++) {
          let flagHelper = level + 1;
          setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogphase_level${i + flagHelper}`]: "" }));
        }

        let setStartLoadingCatalogPhaseByParentActual = setStartLoadingCatalogPhaseByParentLocal[level];

        dispatch(setStartLoadingCatalogPhaseByParentActual());

      }
    } else {

      let setCleanCatalogPhaseLevelActualE = setCleanCatalogPhaseLevelE[level];
      dispatch(setCleanCatalogPhaseLevelActualE());

      let numberOfLevelsIterateE = getLevelsToIterateE[level];

      for (let i = 0; i < numberOfLevelsIterateE; i++) {
        let flagHelperE = level;
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogphase_level${i + flagHelperE}`]: "" }));

        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogphases_id`]: level === 1 ? "" : valuesCiiu[`catalogphase_level${level - 1}`].id }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`catalogphase_levels`]: concatPhaseLevelsNoEvent(values, level) }));

      }
    }
  };

  const handleChangeCatalogInstitution = (event, level) => {

    var setCleanCatalogInstitutionLevel = {
      1: () => cleanCatalogInstitutionLevel1(),
      2: () => cleanCatalogInstitutionLevel2(),
      3: () => cleanCatalogInstitutionLevel3(),

    };

    var setSelectCatalogInstitutionLevel = {
      1: () => selectCatalogInstitutionLevel1(event),
      2: () => selectCatalogInstitutionLevel2(event),
      3: () => selectCatalogInstitutionLevel3(event),

    };

    /*
    var setStartLoadingCatalogInstitutionByParent = {
        1: () => startLoadingCatalogInstitutionByParent(event.id, 2),
        2: () => startLoadingCatalogInstitutionByParent(event.id, 3),
        3: () => startLoadingCatalogInstitutionByParent(event.id, 4),
        4: () => startLoadingCatalogInstitutionByParent(event.id, 5),
    };
    */

    var setStartLoadingCatalogInstitutionByParentLocal = {
      1: () => startLoadingCatalogInstitutionByParentLocal(event.id, 2),
      2: () => startLoadingCatalogInstitutionByParentLocal(event.id, 3),
      3: () => startLoadingCatalogInstitutionByParentLocal(event.id, 4),

    };

    /*var getLevelsToIterate = {
      1: 3,
      2: 2,
      3: 1,
    };*/

    var getLevelsToIterate = {
      1: 2,
      2: 1,

    };

    var setCleanCatalogInstitutionLevelE = {
      1: () => cleanCatalogInstitutionLevel1(),
      2: () => cleanCatalogInstitutionLevel2(),
      3: () => cleanCatalogInstitutionLevel3(),

    };

    var getLevelsToIterateE = {
      1: 3,
      2: 2,
      3: 1,

    };

    if (event != null) {

      if (event.code === 0) {
        setValues((valuesCiiu) => ({ ...valuesCiiu, cataloginstitution_levels: event }));

        dispatch(cleanCatalogInstitutionLevel1());

        dispatch(selectCatalogInstitutionLevel1(event));

        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogInstitutionLevel2: "" }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, catalogInstitutionLevel3: "" }));

      } else {

        setValues((valuesCiiu) => ({ ...valuesCiiu, [`cataloginstitution_level${level}`]: event }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`cataloginstitutions_id`]: event.id }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`cataloginstitution_levels`]: concatInstitutionLevels(valuesCiiu, event, level) }));

        let setCleanCatalogInstitutionLevelActual = setCleanCatalogInstitutionLevel[level];
        dispatch(setCleanCatalogInstitutionLevelActual());

        let setSelectCatalogInstitutionLevelActual = setSelectCatalogInstitutionLevel[level];
        dispatch(setSelectCatalogInstitutionLevelActual());

        let numberOfLevelsIterate = getLevelsToIterate[level];

        for (let i = 0; i < numberOfLevelsIterate; i++) {
          let flagHelper = level + 1;
          setValues((valuesCiiu) => ({ ...valuesCiiu, [`cataloginstitution_level${i + flagHelper}`]: "" }));
        }

        let setStartLoadingCatalogInstitutionByParentActual = setStartLoadingCatalogInstitutionByParentLocal[level];

        dispatch(setStartLoadingCatalogInstitutionByParentActual());

      }
    } else {

      let setCleanCatalogInstitutionLevelActualE = setCleanCatalogInstitutionLevelE[level];
      dispatch(setCleanCatalogInstitutionLevelActualE());

      let numberOfLevelsIterateE = getLevelsToIterateE[level];

      for (let i = 0; i < numberOfLevelsIterateE; i++) {
        let flagHelperE = level;
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`cataloginstitution_level${i + flagHelperE}`]: "" }));

        setValues((valuesCiiu) => ({ ...valuesCiiu, [`cataloginstitutions_id`]: level === 1 ? "" : valuesCiiu[`cataloginstitution_level${level - 1}`].id }));
        setValues((valuesCiiu) => ({ ...valuesCiiu, [`cataloginstitution_levels`]: concatInstitutionLevelsNoEvent(values, level) }));

      }
    }
  };

  const handleChangeLocation = (event, field) => {

    if (field === 'catalogcontinents_id') {
      if (event != null) {

        setValues((values) => ({ ...values, catalogcontinents_id: event }));

        dispatch(cleanContinent());
        setValues((values) => ({ ...values, catalogregions_id: "" }));
        setValues((values) => ({ ...values, catalogcountries_id: "" }));

        dispatch(startLoadingRegionByContinentIdLocal(event.id));
        dispatch(selectContinent(event));
      } else {
        dispatch(cleanContinent());
        setValues((values) => ({ ...values, catalogcontinents_id: "" }));
        setValues((values) => ({ ...values, catalogregions_id: "" }));
        setValues((values) => ({ ...values, catalogcountries_id: "" }));
      }

    } else if (field === 'catalogregions_id') {
      if (event != null) {

        setValues((values) => ({ ...values, catalogregions_id: event }));

        dispatch(cleanRegion());
        setValues((values) => ({ ...values, catalogcountries_id: "" }));

        dispatch(startLoadingCountriesByRegionIdLocal(event.id));
        dispatch(selectRegion(event));
      } else {
        dispatch(cleanRegion());
        setValues((values) => ({ ...values, catalogcountries_id: "" }));
        setValues((values) => ({ ...values, catalogregions_id: "" }));
      }

    } else if (field === 'catalogcountries_id') {
      if (event != null) {

        setValues((values) => ({ ...values, catalogcountries_id: event }));

      } else {

        setValues((values) => ({ ...values, catalogcountries_id: "" }));
      }
    }
  };

  const handleChangeLocationRender = (event, field) => {

    if (field === 'catalogcontinents_id') {
      if (event != null) {

        setValues((values) => ({ ...values, catalogcontinents_id: event }));

      } else {

      }

    } else if (field === 'catalogregions_id') {
      if (event != null) {

        setValues((values) => ({ ...values, catalogregions_id: event }));

      } else {

      }

    } else if (field === 'catalogcountries_id') {

      if (event != null) {

        setValues((values) => ({ ...values, catalogcountries_id: event }));

      } else {

      }
    }
  };

  const getFieldInfo = (searchField) => {
    let fieldFound = {};
    moduleConfigs.forEach((element, index) => {
      if (element.field === searchField) {
        fieldFound = element;
      }
    });
    return fieldFound;
  }

  const isFilledRelationValue = (value) => {
    if (value === null || value === undefined || value === "") {
      return false;
    }
    if (typeof value === "number") {
      return Number.isFinite(value) && value !== 0;
    }
    if (typeof value === "string") {
      const trimmed = value.trim();
      return trimmed.length > 0 && trimmed !== "0";
    }
    if (typeof value === "object") {
      if (value.id !== undefined && value.id !== null && value.id !== "") {
        return true;
      }
      if (value.code !== undefined && value.code !== null && value.code !== "") {
        return true;
      }
      return Object.keys(value).length > 0;
    }
    return Boolean(value);
  };

  const preFormatValues = (values) => {
    syncMultilevelLeafValues(values);
    for (let clave in values) {
      if (typeof values[clave] === 'string') {
        values[clave] = sanitizePlainText(values[clave]);
      }
    }
  };

  const validate = (values) => {

    let errors = {};

    moduleConfigs.forEach((element, index) => {

      if (element.is_required) {
        // CIIU / instituciones / tramos / fases: nivel 2+ es opcional
        // (hoja "No Aplica" o "IND" no tiene hijos).
        const isMultilevelChild = /_level[2-9]$/.test(String(element.field || ''));
        const multilevelValue = values[element.field];
        const multilevelEmpty = !multilevelValue
          || (typeof multilevelValue === 'object' && Object.keys(multilevelValue).length === 0);
        if (isMultilevelChild && multilevelEmpty) {
          return;
        }

        if (element.data_type === "integer" && element.type === "relation") {

          if (!isFilledRelationValue(values[element.field])) {
            addMessageToErrors(`* ${t(`${element.module_text}.short.${element.field}`)} ${t("validations.required")}`, element, errors);

          }

        } else if (element.data_type === "integer" && element.type === "field") {

          if (typeof values[element.field] !== 'object' || (values[element.field] && Object.keys(values[element.field]).length === 0)) {
            addMessageToErrors(`* ${t(`${element.module_text}.short.${element.field}`)} ${t("validations.required")}`, element, errors);

          }

        } else if (element.data_type === "number" && element.type === "field") {

          if (!values[element.field]) {
            addMessageToErrors(`* ${t(`${element.module_text}.short.${element.field}`)} ${t("validations.required")}`, element, errors);

          }

        } else if (element.data_type === "list" && element.type === "relation") {

          if (values[element.field] && values[element.field].length === 0) {
            addMessageToErrors(`* ${t(`${element.module_text}.short.${element.field}`)} ${t("validations.required")}`, element, errors);

          }
        }
        else if (element.data_type === "list" && element.type === "table") {
          if (values.hasOwnProperty("ModuleFile_To_Technology")) {
            values.catalogmultimedia_list = values.ModuleFile_To_Technology;
          } else if (values.hasOwnProperty("ModuleFile_To_Alternative")) {
            values.catalogmultimedia_list = values.ModuleFile_To_Alternative;
          } else if (values.hasOwnProperty("ModuleFile_To_Experience")) {
            values.catalogmultimedia_list = values.ModuleFile_To_Experience;
          } else if (values.hasOwnProperty("ModuleFile_To_Innovation")) {
            values.catalogmultimedia_list = values.ModuleFile_To_Innovation;
          } else if (values.hasOwnProperty("ModuleFile_To_Assistance")) {
            values.catalogmultimedia_list = values.ModuleFile_To_Assistance;
          } else if (values.hasOwnProperty("ModuleFile_To_Financial")) {
            values.catalogmultimedia_list = values.ModuleFile_To_Financial;
          } else if (values.hasOwnProperty("ModuleFile_To_Regulation")) {
            values.catalogmultimedia_list = values.ModuleFile_To_Regulation;
          }

          if (values[element.field] && values[element.field].length === 0) {
            addMessageToErrors(`* ${t(`${element.module_text}.short.${element.field}`)} ${t("validations.required")}`, element, errors);

          }
        }
        else {

          if (values[element.field] instanceof Date) {
            if (!values[element.field]) {
              addMessageToErrors(`* ${t(`${element.module_text}.short.${element.field}`)} ${t("validations.required")}`, element, errors);

            }
          } else if (values[element.field] instanceof Object) {
            if (!values[element.field]) {
              addMessageToErrors(`* ${t(`${element.module_text}.short.${element.field}`)} ${t("validations.required")}`, element, errors);

            }
          } else {
            if (!isFilledRelationValue(values[element.field])) {
              addMessageToErrors(`* ${t(`${element.module_text}.short.${element.field}`)} ${t("validations.required")}`, element, errors);

            }
          }

        }

      }

      if (element.validate_minimum) {

        if (Array.isArray(values[element.field])) {

          if (values[element.field] && values[element.field] < 1) {
            addMessageToErrors(`* ${t(`${element.module_text}.short.${element.field}`)} ${t("validations.length.invalid")}`, element, errors);

          }

        } else {
          if (values[element.field]?.length < 2) {
            addMessageToErrors(`* ${t(`${element.module_text}.short.${element.field}`)} ${t("validations.length.invalid")}`, element, errors);

          }
        }

        ;

      }
      if (shouldApplyRegex(element)) {

        if (element.data_type === "string" && element.type === "field") {
          if (values[element.field]) {
            const regexToValidate = new RegExp(element.regex);
            if (!regexToValidate.test(values[element.field])) {
              addMessageToErrors(`* ${t(`${element.module_text}.short.${element.field}`)} ${t("validations.invalid")}`, element, errors);
            }
          }
        } else if (element.data_type === "number" && element.type === "field") {
          const regexToValidateString = element.regex;
          //console.log("2222, regex, number, regexToValidateString", regexToValidateString);

          let regexToValidate = new RegExp(regexToValidateString);
          //console.log("2222, regex, number, regexToValidate", regexToValidate);

          if (!regexToValidate.test(values[element.field])) {
            //console.log("2222, regex, number, inside if", regexToValidate);
            addMessageToErrors(`* ${t(`${element.module_text}.short.${element.field}`)} ${t("validations.invalid")}`, element, errors);

          }
        }

      }

      if (element.validate_unique) {
        if (element.unique_condition === "date") {
          if (values[element.field] > new Date()) {
            addMessageToErrors(`* ${t(`${element.module_text}.short.${element.field}`)} ${t("validations.date.invalid")}`, element, errors);

          }
        } else if (element.unique_condition === "year") {
          const yearActual = new Date();
          yearActual.setFullYear(yearActual.getFullYear() + 1);

          if (values[element.field] > yearActual) {
            addMessageToErrors(`* ${t(`${element.module_text}.short.${element.field}`)} ${t("validations.date.invalid")}`, element, errors);

          }
        }
      }

    });

    return errors;
  };

  const addMessageToErrors = (textToAdd, element, errorsLocal) => {
    if (errorsLocal[element.field]) {
      errorsLocal[element.field] = `${errorsLocal[element.field]}\n${textToAdd}`;
    } else {
      errorsLocal[element.field] = `${textToAdd}`;
    }
  }

  const concatCiiuLevels = (values, event, level) => {
    let codeConcat = "";

    if (level === 6) {
      codeConcat = codeConcat.concat(values.catalogciiu_level1 && values.catalogciiu_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level2 && values.catalogciiu_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level3 && values.catalogciiu_level3.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level4 && values.catalogciiu_level4.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level5 && values.catalogciiu_level5.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 5) {
      codeConcat = codeConcat.concat(values.catalogciiu_level1 && values.catalogciiu_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level2 && values.catalogciiu_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level3 && values.catalogciiu_level3.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level4 && values.catalogciiu_level4.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 4) {
      codeConcat = codeConcat.concat(values.catalogciiu_level1 && values.catalogciiu_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level2 && values.catalogciiu_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level3 && values.catalogciiu_level3.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 3) {
      codeConcat = codeConcat.concat(values.catalogciiu_level1 && values.catalogciiu_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level2 && values.catalogciiu_level2.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 2) {
      codeConcat = codeConcat.concat(values.catalogciiu_level1 && values.catalogciiu_level1.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 1) {
      codeConcat = codeConcat.concat(event.code);

      return codeConcat
    }

    return codeConcat;
  }

  const concatCiiuLevelsNoEvent = (values, level) => {
    let codeConcat = "";

    if (level === 6) {
      codeConcat = codeConcat.concat(values.catalogciiu_level1 && values.catalogciiu_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level2 && values.catalogciiu_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level3 && values.catalogciiu_level3.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level4 && values.catalogciiu_level4.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level5 && values.catalogciiu_level5.code);

      return codeConcat
    } else if (level === 5) {
      codeConcat = codeConcat.concat(values.catalogciiu_level1 && values.catalogciiu_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level2 && values.catalogciiu_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level3 && values.catalogciiu_level3.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level4 && values.catalogciiu_level4.code);

      return codeConcat
    } else if (level === 4) {
      codeConcat = codeConcat.concat(values.catalogciiu_level1 && values.catalogciiu_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level2 && values.catalogciiu_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level3 && values.catalogciiu_level3.code);

      return codeConcat
    } else if (level === 3) {
      codeConcat = codeConcat.concat(values.catalogciiu_level1 && values.catalogciiu_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogciiu_level2 && values.catalogciiu_level2.code);

      return codeConcat
    } else if (level === 2) {
      codeConcat = codeConcat.concat(values.catalogciiu_level1 && values.catalogciiu_level1.code);

      return codeConcat
    } else if (level === 1) {
      codeConcat = "";

      return codeConcat
    }

    return codeConcat;
  }

  const concatSectionLevels = (values, event, level) => {
    let codeConcat = "";

    if (level === 6) {
      codeConcat = codeConcat.concat(values.catalogsection_level1 && values.catalogsection_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level2 && values.catalogsection_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level3 && values.catalogsection_level3.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level4 && values.catalogsection_level4.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level5 && values.catalogsection_level5.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 5) {
      codeConcat = codeConcat.concat(values.catalogsection_level1 && values.catalogsection_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level2 && values.catalogsection_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level3 && values.catalogsection_level3.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level4 && values.catalogsection_level4.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 4) {
      codeConcat = codeConcat.concat(values.catalogsection_level1 && values.catalogsection_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level2 && values.catalogsection_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level3 && values.catalogsection_level3.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 3) {
      codeConcat = codeConcat.concat(values.catalogsection_level1 && values.catalogsection_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level2 && values.catalogsection_level2.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 2) {
      codeConcat = codeConcat.concat(values.catalogsection_level1 && values.catalogsection_level1.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 1) {
      codeConcat = codeConcat.concat(event.code);

      return codeConcat
    }

    return codeConcat;
  }

  const concatSectionLevelsNoEvent = (values, level) => {
    let codeConcat = "";

    if (level === 6) {
      codeConcat = codeConcat.concat(values.catalogsection_level1 && values.catalogsection_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level2 && values.catalogsection_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level3 && values.catalogsection_level3.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level4 && values.catalogsection_level4.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level5 && values.catalogsection_level5.code);

      return codeConcat
    } else if (level === 5) {
      codeConcat = codeConcat.concat(values.catalogsection_level1 && values.catalogsection_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level2 && values.catalogsection_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level3 && values.catalogsection_level3.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level4 && values.catalogsection_level4.code);

      return codeConcat
    } else if (level === 4) {
      codeConcat = codeConcat.concat(values.catalogsection_level1 && values.catalogsection_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level2 && values.catalogsection_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level3 && values.catalogsection_level3.code);

      return codeConcat
    } else if (level === 3) {
      codeConcat = codeConcat.concat(values.catalogsection_level1 && values.catalogsection_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogsection_level2 && values.catalogsection_level2.code);

      return codeConcat
    } else if (level === 2) {
      codeConcat = codeConcat.concat(values.catalogsection_level1 && values.catalogsection_level1.code);

      return codeConcat
    } else if (level === 1) {
      codeConcat = "";

      return codeConcat
    }

    return codeConcat;
  }

  const concatPhaseLevels = (values, event, level) => {
    let codeConcat = "";

    if (level === 6) {
      codeConcat = codeConcat.concat(values.catalogphase_level1 && values.catalogphase_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level2 && values.catalogphase_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level3 && values.catalogphase_level3.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level4 && values.catalogphase_level4.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level5 && values.catalogphase_level5.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 5) {
      codeConcat = codeConcat.concat(values.catalogphase_level1 && values.catalogphase_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level2 && values.catalogphase_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level3 && values.catalogphase_level3.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level4 && values.catalogphase_level4.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 4) {
      codeConcat = codeConcat.concat(values.catalogphase_level1 && values.catalogphase_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level2 && values.catalogphase_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level3 && values.catalogphase_level3.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 3) {
      codeConcat = codeConcat.concat(values.catalogphase_level1 && values.catalogphase_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level2 && values.catalogphase_level2.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 2) {
      codeConcat = codeConcat.concat(values.catalogphase_level1 && values.catalogphase_level1.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 1) {
      codeConcat = codeConcat.concat(event.code);

      return codeConcat
    }

    return codeConcat;
  }

  const concatPhaseLevelsNoEvent = (values, level) => {
    let resultConcat = "";
    let codeConcat = "";

    if (level === 6) {
      codeConcat = codeConcat.concat(values.catalogphase_level1 && values.catalogphase_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level2 && values.catalogphase_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level3 && values.catalogphase_level3.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level4 && values.catalogphase_level4.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level5 && values.catalogphase_level5.code);

      return codeConcat
    } else if (level === 5) {
      codeConcat = codeConcat.concat(values.catalogphase_level1 && values.catalogphase_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level2 && values.catalogphase_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level3 && values.catalogphase_level3.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level4 && values.catalogphase_level4.code);

      return codeConcat
    } else if (level === 4) {
      codeConcat = codeConcat.concat(values.catalogphase_level1 && values.catalogphase_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level2 && values.catalogphase_level2.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level3 && values.catalogphase_level3.code);

      return codeConcat
    } else if (level === 3) {
      codeConcat = codeConcat.concat(values.catalogphase_level1 && values.catalogphase_level1.code);
      codeConcat = codeConcat.concat(";", values.catalogphase_level2 && values.catalogphase_level2.code);

      return codeConcat
    } else if (level === 2) {
      codeConcat = codeConcat.concat(values.catalogphase_level1 && values.catalogphase_level1.code);

      return resultConcat
    } else if (level === 1) {
      codeConcat = "";

      return codeConcat
    }

    return codeConcat;
  }

  const concatInstitutionLevels = (values, event, level) => {
    let codeConcat = "";

    if (level === 6) {
      codeConcat = codeConcat.concat(values.cataloginstitution_level1 && values.cataloginstitution_level1.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level2 && values.cataloginstitution_level2.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level3 && values.cataloginstitution_level3.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level4 && values.cataloginstitution_level4.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level5 && values.cataloginstitution_level5.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 5) {
      codeConcat = codeConcat.concat(values.cataloginstitution_level1 && values.cataloginstitution_level1.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level2 && values.cataloginstitution_level2.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level3 && values.cataloginstitution_level3.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level4 && values.cataloginstitution_level4.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 4) {
      codeConcat = codeConcat.concat(values.cataloginstitution_level1 && values.cataloginstitution_level1.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level2 && values.cataloginstitution_level2.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level3 && values.cataloginstitution_level3.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 3) {
      codeConcat = codeConcat.concat(values.cataloginstitution_level1 && values.cataloginstitution_level1.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level2 && values.cataloginstitution_level2.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 2) {
      codeConcat = codeConcat.concat(values.cataloginstitution_level1 && values.cataloginstitution_level1.code);
      codeConcat = codeConcat.concat(";", event.code);

      return codeConcat
    } else if (level === 1) {
      codeConcat = codeConcat.concat(event.code);

      return codeConcat
    }

    return codeConcat;
  }

  const concatInstitutionLevelsNoEvent = (values, level) => {
    let codeConcat = "";

    if (level === 6) {
      codeConcat = codeConcat.concat(values.cataloginstitution_level1 && values.cataloginstitution_level1.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level2 && values.cataloginstitution_level2.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level3 && values.cataloginstitution_level3.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level4 && values.cataloginstitution_level4.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level5 && values.cataloginstitution_level5.code);

      return codeConcat
    } else if (level === 5) {
      codeConcat = codeConcat.concat(values.cataloginstitution_level1 && values.cataloginstitution_level1.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level2 && values.cataloginstitution_level2.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level3 && values.cataloginstitution_level3.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level4 && values.cataloginstitution_level4.code);

      return codeConcat
    } else if (level === 4) {
      codeConcat = codeConcat.concat(values.cataloginstitution_level1 && values.cataloginstitution_level1.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level2 && values.cataloginstitution_level2.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level3 && values.cataloginstitution_level3.code);

      return codeConcat
    } else if (level === 3) {
      codeConcat = codeConcat.concat(values.cataloginstitution_level1 && values.cataloginstitution_level1.code);
      codeConcat = codeConcat.concat(";", values.cataloginstitution_level2 && values.cataloginstitution_level2.code);

      return codeConcat
    } else if (level === 2) {
      codeConcat = codeConcat.concat(values.cataloginstitution_level1 && values.cataloginstitution_level1.code);

      return codeConcat
    } else if (level === 1) {
      codeConcat = "";

      return codeConcat
    }

    return codeConcat;
  }

  return {
    handleChange,
    handleChangeMulti,
    handleChangeCatalogCiiu,
    handleChangeCatalogSection,
    handleChangeCatalogPhase,
    handleChangeCatalogInstitution,
    handleChangeLocation,
    handleChangeLocationRender,
    handleSubmit,
    values,
    errors,
    setValues,
  };
};

export default useFormValidations;